var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewTopicNeutral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 667.47 667.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #986502;\n      }\n\n      .cls-2 {\n        fill: #FCEAD4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 333.74,
    cy: 333.74,
    r: 333.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 209.51,
    cy: 255.45,
    r: 40.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 457.97,
    cy: 255.45,
    r: 40.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.08,
    y: 407.11,
    width: 391.31,
    height: 44.71,
    rx: 10.8,
    ry: 10.8,
    transform: "translate(-43.41 37.57) rotate(-6.05)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewTopicNeutral);
export default __webpack_public_path__ + "static/media/review-topic-neutral.20c1f2c8ee242cc2f2ac27ec733296e5.svg";
export { ForwardRef as ReactComponent };